import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useStates(countryCode) {
  const [states, setStates] = useState([]);

  useEffect(() => {
    if (countryCode === 'US') {
      axios
        .get(routes.api.countries.states(countryCode))
        .then((response) => {
          setStates(response.data.data);
        });
    } else {
      setStates([]);
    }
  }, [countryCode]);

  return states;
}
